<template>
  <v-alert
    v-model="showMigrationAlert"
    type="warning"
    icon="new_releases"
  >
    <div class="white--text">
      Coming Soon: An improved PlayPosit experience! Your account will be moving to <a href="http://wevideo.com/" target="_blank">WeVideo</a>. Check your email for additional information and learn more <a href="https://support.wevideo.com/hc/en-us/articles/35643878747291-PlayPosit-Free-Account-Migration-to-WeVideo-Everything-You-Need-to-Know" target="_blank">here</a>.
    </div>
  </v-alert>
</template>

<script>
import {
  mapState,
} from 'vuex';
import _ from 'lodash';
import {
  MIGRATION_BATCHES,
} from '@Constants';

export default {
  name: 'MigrationAlert',
  data() {
    return {
      showMigrationAlert: false,
    };
  },
  computed: {
    ...mapState([
      'instructorData',
    ]),
  },
  mounted() {
    this.showMigrationAlert = (
      MIGRATION_BATCHES.ONE.includes(this.instructorData.id)
      || MIGRATION_BATCHES.TWO.includes(this.instructorData.id)
      || MIGRATION_BATCHES.THREE.includes(this.instructorData.id)
      || MIGRATION_BATCHES.FOUR.includes(this.instructorData.id)
    )
  },
};
</script>
